function Footer() {
	return (
		<footer className="bg-gradient-to-b from-gray-900  to-black text-white text-center py-4 quicksand h-full">
			<p>
				&copy; {new Date().getFullYear()} PLAN B4
				<br />
				All rights reserved.

			</p>

			<a
				href="/tos"
				className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium transition-colors"
			>
				Terms
			</a>
		</footer>
	)
}

export default Footer
